// extracted by mini-css-extract-plugin
module.exports = {"cardBodyWrapper":"PositionCard-module--cardBodyWrapper--2bvyr","cardScale":"PositionCard-module--cardScale--3BQp4"};